// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2026-05-12T12:08:59+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  192125
//    Project:        617
//    Environment:    7626 - master
//    MD5:            1c9859b510ac48f1c64e39dd54942eec
//    Signature:      eyJpdiI6IlMrZWtRdHFmXC9tV3ZpQzMrdGN2SFdnPT0iLCJ2YWx1ZSI6InAxRjI5eHlBMllRaStKNEg2a0tIU1lRNHNjSmR6WWRhMnpOcEU1KzNDSEN5XC85eWNXeHpjZXN4NEpCejc1RlwvRlZPak9RY3RIYUVkeWJ2WVM0RlwvTFwvcXhXSk5MYVRDOUZpMzdKaVRRSW5WYVRCTWthbFdhREZcL1wvdHBpNXA4aERcL1RoZ3QzaGRqSTJEa2l0dEN5aUhtaFFxQWh1RVdmamV2NzZqb0ZEajBTakJ0R2FsU3NyelpNMHhtbXpNK2paWWpSZHJ4NlB5UitLQXRtXC9lcmN1XC8xU0VJUW5DVm9kNHdsRG1WQXFJcEZtT3B1UHhUQ1JtR0U2QWNMTlZIK295bkdqUVwvYVFubVEzeDd0R0pobVRIaU9JcFYzU1ZSTzdwazZKd0xleXJVNnZtNHZpbWxEQmhhTUJ3Vk9LcTJ6WEN4QW9TVjJiQUxLQ3g2RURXUGo1M3ZLTzUyUEhHeWhORGNxTlFPSkhEalY2MUZHTjZ4bDIwRm96TWVrWG5vV0VYY2Vkd1ZwWDRaREdzRmVWK2FWSXI3anFBPT0iLCJtYWMiOiJmZGFkNDBjNmU0ODFjODY1ZDJjMjZiNWEzODk0Y2YzZjQxZjI3NWMxNjM0Mzk0YjcxYWMwNWIzMWExYWQ4MjdkIn0=
if (!customElements.get('share-button')) {
  customElements.define(
    'share-button',
    class ShareButton extends DetailsDisclosure {
      constructor() {
        super();

        this.elements = {
          shareButton: this.querySelector('button'),
          shareSummary: this.querySelector('summary'),
          closeButton: this.querySelector('.share-button__close'),
          successMessage: this.querySelector('[id^="ShareMessage"]'),
          urlInput: this.querySelector('input'),
        };
        this.urlToShare = this.elements.urlInput ? this.elements.urlInput.value : document.location.href;

        if (navigator.share) {
          this.mainDetailsToggle.setAttribute('hidden', '');
          this.elements.shareButton.classList.remove('hidden');
          this.elements.shareButton.addEventListener('click', () => {
            navigator.share({ url: this.urlToShare, title: document.title });
          });
        } else {
          this.mainDetailsToggle.addEventListener('toggle', this.toggleDetails.bind(this));
          this.mainDetailsToggle
            .querySelector('.share-button__copy')
            .addEventListener('click', this.copyToClipboard.bind(this));
          this.mainDetailsToggle.querySelector('.share-button__close').addEventListener('click', this.close.bind(this));
        }
      }

      toggleDetails() {
        if (!this.mainDetailsToggle.open) {
          this.elements.successMessage.classList.add('hidden');
          this.elements.successMessage.textContent = '';
          this.elements.closeButton.classList.add('hidden');
          this.elements.shareSummary.focus();
        }
      }

      copyToClipboard() {
        navigator.clipboard.writeText(this.elements.urlInput.value).then(() => {
          this.elements.successMessage.classList.remove('hidden');
          this.elements.successMessage.textContent = window.accessibilityStrings.shareSuccess;
          this.elements.closeButton.classList.remove('hidden');
          this.elements.closeButton.focus();
        });
      }

      updateUrl(url) {
        this.urlToShare = url;
        this.elements.urlInput.value = url;
      }
    }
  );
}
